export default __webpack_public_path__ + "static/media/clear-day.356403cc.svg";